import { gql } from '@apollo/client';

export const GET_PORTFOLIO_EMAILS = gql`
  query GetPortfolioEmails($portfolioCodes: [String!], $employeeEmail: String) {
    portfolioEmails(portfolioCodes: $portfolioCodes, employeeEmail: $employeeEmail) {
      recId
      portfolioCode
      employeeEmail
      employeeFullName
      employeeType
    }
  }
`;
